import { journeyAction, } from './base';

import { JourneyActionVoiceSetLanguage as JourneyActionVoiceSetLanguageBase, } from 'atlas-shared';

export const JourneyActionVoiceSetLanguage = journeyAction({
  ...JourneyActionVoiceSetLanguageBase,
  icon: 'Language',
});
